import React from 'react'

const FooterSectionFive = () => {
    return (
        <>
            <h3 className="footer-title2">
                Sign Up to <span>News letter</span>
            </h3>
            <p className="address-pera">
                Subscribe our newsletter gor get notification about information
                discount.
            </p>
            <div className="newsletter-bx">
                <form method="get" action="#">
                    <input type="email" placeholder="Your email address" />
                    <button type="submit" className="search-icon">
                        Subscribe
                    </button>
                </form>
            </div>
            <ul className="f-social">
                <li>GET IN TOUCH !</li>
                <li>
                    <a href="#" target="_blank">
                        <i className="fa fa-facebook" />
                    </a>
                </li>
                <li>
                    <a href="#" target="_blank">
                        <i className="fa fa-twitter" />
                    </a>
                </li>
                <li>
                    <a href="#" target="_blank">
                        <i className="fa fa-rss" />

                        
                    </a>
                </li>
                <li>
                    <a href="#" target="_blank">
                        <i className="fa fa-pinterest" />
                    </a>
                </li>
                <li>
                    <a href="#" target="_blank">
                        <i className="fa fa-instagram" />
                    </a>
                </li>
            </ul>
        </>
    )
}

export default FooterSectionFive